<template>
    <div ref="scrollPointer" class="twoLvlSlider__inner--slider">
        <swiper
            :id="mainSliderId"
            :modules="modules"
            :slides-per-view="1"
            :space-between="8"
            :speed="700"
            :initialSlide="current"
            :breakpoints="{
             '768': {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: true
              },
            }"
            :loop="false"
            @slideChange="onSlideChange"
        >
            <slot name="default"/>
        </swiper>
        <div class="button-wrapper" v-if="show_arrows">
            <div  class="swiper-navigation swiper-prev" @click="navigate(mainSliderId,'prev')"><svg width="18" height="54" viewBox="0 0 18 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.78125 26.9958L16.6308 0.806641L17.2289 1.8655L2.02016 26.9958L17.2289 52.1261L16.6308 53.1143L0.78125 26.9958Z" fill="black"/>
            </svg></div>
            <div  class="swiper-navigation swiper-next" @click="navigate(mainSliderId,'next')"><svg width="17" height="54" viewBox="0 0 17 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4473 26.9958L0.597733 0.806641L-0.000362396 1.8655L15.2084 26.9958L-0.000362396 52.1261L0.597733 53.1143L16.4473 26.9958Z" fill="black"/>
            </svg></div>
        </div>
    </div>

    <div class="twoLvlSlider__inner--tabSlider">
        <div class="tab-slider__box">
            <div class="tab-slider__inner">
                <div class="tab-slider__panelWrapper">
                    <div class="tab-slider__panel" :class="tabCount()">
                        <div class="tab-slider__panel--wrap">
                            <div ref="tabBar" class="mdc-tab-bar" role="tablist">
                                <div class="mdc-tab-scroller">
                                    <div class="mdc-tab-scroller__scroll-area">
                                        <div class="mdc-tab-scroller__scroll-content">
                                            <button
                                                v-for="(slot, i) in slotTabs"
                                                :class="tabClass(i)"
                                                role="tab" aria-selected="true"
                                                :data-target="slot.props.id"
                                                :data-test="slot.props.id"
                                                @click="setActiveItem(i)"
                                                :tabindex="i"
                                            >
                                            <span class="mdc-tab__content">
                                                <span class="mdc-tab__text-label" v-text="slot.props.tabheadline" />
                                            </span>
                                            <span :class="indicatorClass(i)">
                                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                                            </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-slider__border"></div>
                    </div>
                </div>
                <div class="tab-slider__content">
                    <div ref="wrap" class="tab-slider__content--wrap">
                        <div v-if="mobile">
                            <div class="tab-slider__target" v-for="(slot, i) in slotTabSlider"
                                 :class="{ active: i === current }">
                                <two-level-slider-tab-slider :sliderData="slot.children"></two-level-slider-tab-slider>
                            </div>
                        </div>
                        <div v-else>
                            <div class="tab-slider__target" v-for="(slot, i) in slotTabs"
                                 :class="{ active: i === current}">
                                <render-vnode :v-node="slot"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {computed, onMounted, ref, useSlots} from "vue";
import {Autoplay, Pagination, Navigation} from "swiper";
import {Swiper, SwiperSlide} from "swiper/vue";
import {windowOrientation, breakpointState} from "@/utils";
import TwoLevelSliderTabSlider from "@/components/TwoLevelSlider/TwoLevelTabSlider.vue";
import TabSlider from "@/components/TabSlider.vue";
import {MDCTabBar} from "@material/tab-bar";

export default {
    name: "two-level-slider",
    components: {
        TwoLevelSliderTabSlider,
        Swiper,
        SwiperSlide,
        TabSlider
    },
    props: {
        swiperid: String,
    },
    setup(props) {
        //Slots
        const slots = useSlots().default();
        const slotTabs = useSlots().tab();
        const slotTabSlider = useSlots().tabslider();

        //Refs
        const bar = ref();

        const findCurrentHash = () => {
            if (
                window.location.hash !== ""
            ) {
                let hash = window.location.hash;
                if (hash.split('-')[0] === "#twoLvlSlide") {
                    let hashIndex = slotTabs.findIndex((elem) => {
                        return elem.props['data-hash']===hash
                    })
                    if (hashIndex !== -1) {
                        scrollPointer.value.scrollIntoView({ behavior: "smooth" });
                        setTimeout(() => {
                            setActiveItem(hashIndex);
                        },1000)
                    }
                }
            }
        }

        const current = ref(0);
        const mainSliderId = 'mainslider'+props.swiperid;
        const tabBar = ref();
        const tabBarObj = ref();
        const scrollPointer = ref();

        //Windows Functions
        const mobile = computed(() => {
            return breakpointState.value.cur === 'mobile';
        });
        const tablet = computed(() => {
            return breakpointState.value.cur === 'tablet_landscape';
        });
        const desktop = computed(() => {
            return breakpointState.value.cur === 'desktop';
        });
        const show_arrows = computed(() => {
            return windowOrientation.value.width >  1540;
        });

        //Application Functions
        const tabCount = () => {
            return 'c_' + slotTabs.length;
        };

        const setActiveItem = (index) => {
            if (current.value !== index) {
                current.value = index;

                const slider = document.getElementById(mainSliderId).swiper;
                if (slider.realIndex !== current.value) {
                    slider.slideToLoop(current.value);
                }
            }
        };

        const onSlideChange = (swiper) => {
            if (swiper.isEnd) {
                //swiper.wrapperEl.classList.add('is-end');
            } else {
                //swiper.wrapperEl.classList.remove('is-end');
            }
            const slider = document.getElementById(mainSliderId).swiper;
            if (slider.realIndex !== current.value) {
                current.value = slider.realIndex;
                tabBarObj.value.activateTab(current.value);
            }
        };

        const tabClass = i => {
            return i!==current.value?'mdc-tab':'mdc-tab mdc-tab--active';
        }

        const indicatorClass = i => {
            return i!==current.value?'mdc-tab-indicator':'mdc-tab-indicator mdc-tab-indicator--active';
        }

        onMounted(() => {
            tabBarObj.value = new MDCTabBar(tabBar.value);
            findCurrentHash()
        });

        return {
            slots,
            slotTabs,
            slotTabSlider,
            tabBar,
            mobile,
            tablet,
            desktop,
            show_arrows,
            bar,
            current,
            mainSliderId,
            scrollPointer,
            tabClass,
            indicatorClass,
            tabCount,
            setActiveItem,
            onSlideChange,
            modules: [Autoplay, Pagination, Navigation],
        };
    },
    methods: {
        navigate(id, direction) {
            const slider = document.getElementById(id).swiper;
            if( direction === 'next'){
                slider.slideNext();
            }
            if( direction === 'prev'){
                slider.slidePrev();
            }
        }
    }
};
</script>

<style lang="scss">
@use "@/scss/design-library/placeholders";
@use "@/scss/design-library/grid";
@use "@/scss/design-library/colors";
@use "@/scss/design-library/typography";
@use "@/scss/design-library/variables";
@use "@/scss/design-library/functions/calculate";

$factSheetBoxWidth: 220px;

.twoLvlSlider {
    position: relative;
    @include grid.inner();

    .teaser-image {
        position: relative;
        z-index: 1;
    }

    .teaser-wrapper {
        &:before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            display: block;
            width: 100%;
            height: 100%;
            background: #{variables.$default-text-gradient};
            opacity: 1;
        }
    }
    .teaser-content {
        position: relative;
        z-index: 3;
    }

    .twoLvlSlider__inner--slider,
    .twoLvlSlider__inner--tabSlider {
        position: relative;
        @include grid.cell-span_(12);
    }

    .twoLvlSlider__inner--slider {
        @extend %teaser;
        z-index: 100;

        .swiper-wrapper {
            transition: all 1s;

            .swiper-slide {
                height: auto;
            }

            .teaser-wrapper {
                width: 100%;
                height: 100%;
                min-height: calculate.rem(360);
                align-items: center;

                @include grid.media-query_up_(tablet_portrait) {
                    min-height: calculate.rem(458);
                    align-items: flex-start;
                }

                .teaser-content {
                    * {
                        &:visited,
                        &:focus {
                            text-decoration: none;
                        }
                    }

                    padding-left: #{calculate.rem(16)};

                    @include grid.media-query_up_(tablet_portrait) {
                        padding-left: #{calculate.rem(53)};
                        padding-top: #{calculate.rem(57)};
                        padding-bottom: #{calculate.rem(75)};
                    }

                    @include grid.media-query_up_(tablet_landscape) {
                        padding-left: #{calculate.rem(72)};
                        padding-top: #{calculate.rem(59)};
                    }

                    @include grid.media-query_up_(desktop) {
                        padding-left: #{calculate.rem(105)};
                        padding-top: #{calculate.rem(40)};
                    }
                }

                .overline {
                    @include typography.subtitle1();
                    margin-block-end: #{calculate.rem(4)};
                }

                .h1 {
                    margin-bottom: 10px;
                }

                .body-text,
                .body-text p {
                    font-size: calculate.rem(20);
                    line-height: calculate.rem(26);

                    a {
                        color: inherit;
                    }
                }

                .body-text {
                    display: none;
                    @include grid.media-query_up_(tablet_portrait) {
                        display: block;
                    }
                }
            }
        }

        .button-wrapper {
            position: absolute;
            display: flex;
            justify-content: space-between;
            align-items: center;
            top: 0;
            left: 0;
            right: 0;
            height: 100%;
            padding: inherit;

            .swiper-navigation {
                cursor: pointer;

                &.swiper-prev {
                    margin-left: -40px
                }

                &.swiper-next {
                    margin-right: -40px
                }
            }
        }
    }

    .twoLvlSlider__inner--tabSlider {
        z-index: 200;

        .tab-slider {
            &__box {
                position: relative;
                @include grid.media-query_up_(tablet_portrait) {
                    max-width: 95%;
                }
            }

            &__inner {
                @include grid.media-query_up_(tablet_portrait) {
                    background: #{colors.$white};
                    padding: 0 #{calculate.rem(20)} #{calculate.rem(20)};
                    box-shadow: 0 20px 75px rgba(0, 0, 0, 0.1);
                    border-radius: #{calculate.rem(16)};
                }
            }

            &__panelWrapper {
                position: relative;
                display: flex;
                margin-bottom: 25px;

                .tab-slider__panel {
                    width: 100%;

                    .tab-slider__panel--wrap {
                        margin-bottom: unset;
                    }

                    @include grid.media-query_up_(tablet_portrait) {
                        width: auto;
                    }
                }

                @include grid.media-query_up_(tablet_portrait) {
                    justify-content: center;
                }
            }

            &__content {
                .tab-slider__factsheet-inner {
                    display: block;
                    width: 100%;
                    height: 100%;

                    @include grid.media-query_up_(tablet_portrait) {
                        max-width: calc($factSheetBoxWidth * 3) + calc($factSheetBoxWidth / 3);
                        min-width: calc($factSheetBoxWidth * 3);

                        &.c_0,
                        &.c_1,
                        &.c_2,
                        &.c_3 {
                            width: calc($factSheetBoxWidth * 3);

                            .tab-slider__factsheet-inner-wrapper {
                                justify-content: center;
                            }
                        }

                        .tab-slider__factsheet-tabs {
                            display: flex;
                        }

                        .tab-slider__factsheet-inner-wrapper {
                            justify-content: left;
                            display: flex;
                        }
                    }

                    @include grid.media-query_up_(desktop) {
                        max-width: calc($factSheetBoxWidth * 5) + calc($factSheetBoxWidth / 3);

                        &.c_0,
                        &.c_1,
                        &.c_2,
                        &.c_3 {
                            width: 100%;
                        }
                        &.c_4 {
                            width: calc($factSheetBoxWidth * 4);
                        }
                    }
                }

                .ps .tab-slider__factsheet-tabs {
                    padding-bottom: 20px;
                }
            }
        }

        @include grid.media-query_up_(tablet_portrait) {
            display: flex;
            justify-content: center;
            margin-top: -75px;

            .tab-slider__tabs {
                justify-content: center;
            }
        }

        .factSheet-element {
            display: block;
            padding: 5px;

            a {
                text-decoration: none;
            }

            .headline {
                color: #{colors.$black};
            }

            .tag,
            .body-text {
                font-size: #{calculate.rem(14)};
                line-height: #{calculate.rem(18)};
                color: #{colors.$anthrazit};
                word-break: break-word;
                hyphens: auto;
            }

            .tag {
                margin-bottom: 5px;
            }

            .dplus-label-wrapper {
                margin-top: 15px;
            }

            @include grid.media-query_up_(tablet_portrait) {
                width: calc($factSheetBoxWidth - 10px);
            }
        }
    }
}

</style>
